export const brand = {
    id: '',
    name: ''
}

export const vehicleBrand = {
    id: '',
    name: ''
}